import { useGetDeepActivity } from 'api';
import { FocusFile } from '../shared/file-importer/types';
import { ImportSelections } from './use-focus-import-selections';
import { getAnnotationTimingInfo, getTimeAlignments } from './annotation-alignment-utils';
import { useCallback } from 'react';
import { AnnotationCategory } from 'api/annotations';

// todo replace with api definition
export interface Annotation {
    annotation_layer_id: string;
    period_id: string | undefined;
    annotation_category_id: string;
    name: string;
    start_time_ms: number;
    end_time_ms: number;
    comment: string;
    athlete_ids: string[];
    imported_id: string;
}

export const useFocusAthleteAnnotationMapper = (
    activityId: string,
): ((
    annotationCategories: AnnotationCategory[],
    focusFile: FocusFile | undefined,
    selections: ImportSelections,
) => Annotation[]) => {
    const { data: activityData } = useGetDeepActivity(activityId);
    const activity = activityData?.[0];

    return useCallback(
        (
            annotationCategories: AnnotationCategory[],
            focusFile: FocusFile | undefined,
            selections: ImportSelections,
        ) => {
            const timeAlignments = getTimeAlignments(selections, activity, focusFile);

            const athleteTagsMap = new Map<string, FocusFile['tags']>();
            selections.athleteAssignment.forEach((tagName, athleteId) => {
                const tagsForAthlete = focusFile?.tags.filter((athleteTag) => athleteTag.tagName === tagName) || [];
                athleteTagsMap.set(athleteId, tagsForAthlete);
            });

            return Array.from(athleteTagsMap.entries())
                .map(([athleteId, tags]) => {
                    return tags.map((tag) => {
                        const timingInfo = getAnnotationTimingInfo(timeAlignments, tag, focusFile);

                        return {
                            annotation_layer_id: focusFile?.session.sessionId ?? '',
                            period_id: undefined,
                            annotation_category_id:
                                annotationCategories.find((cat) => cat.source_name === tag.tagName)?.id ?? '',
                            name: tag.tagName,
                            start_time_ms: timingInfo.startTime,
                            end_time_ms: timingInfo.endTime,
                            comment: 'string',
                            athlete_ids: [athleteId],
                            imported_id: tag.tagId,
                        };
                    });
                })
                .flatMap((a) => a);
        },
        [activity],
    );
};
